import * as Yup from "yup";

const validationSchema = Yup.object({
  username: Yup.string().required("Username is required."),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters.")
    .required("Password is required."),
  company: Yup.object().required("Company is required."),
});

export { validationSchema };
